import { Component, Input } from '@angular/core';

import { VersionShareFeedbackMessage, VersionShareFeedbackMessageType } from '@core/models/version-share-message.model';
import { VersionShareType, ApprovalStatusCodeEnum } from '@core/models/version-share.model';

@Component({
    selector: 'core-message-version-share-feedback',
    templateUrl: './message-version-share-feedback.component.html',
    styleUrls: ['./message-version-share-feedback.component.scss']
})
export class MessageVersionShareFeedbackComponent {

    public readonly VERSION_SHARE_MESSAGE_TYPE = VersionShareFeedbackMessageType;
    public readonly VERSION_SHARE_APPROVAL_STATUS = ApprovalStatusCodeEnum;

    // ApprovalStatusCodeEnum {
    //     PENDING_CODE = 0,
    //     APPROVED_CODE = 1,
    //     REJECTED_CODE = 2
    
    @Input() message: VersionShareFeedbackMessage;
    
}
